import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { ClipLoader } from 'react-spinners';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getName } from '../../../Redux/selecters';

const UpdateSupplier = () => {
    const apiService = new ApiService();
    let navigate = useNavigate();
    const [loading, setLoader] = useState(false)
    const [accountList, setAccountList] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [termList, setTermList] = useState([]);
    const [taxList, setTaxList] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [bankList, setBankList] = useState([]);
    const [bankCategoryList, setBankCategoryList] = useState([]);
    const [subGroupList, setSubGroupList] = useState([]);
    const [FYear, setFiinancialYear] = useState(null);
    const fulname = useSelector(getName);
    const location = useLocation();
    const supplierData = location.state;

    const [supplierdata, setSupplierData] = useState({
        subgroup: null,
        accountcode: '',
        accountname: '',
        creditfacility: false,
        vatRegistered: false,
        createLedger: false,
        SapAccountCode: false,
        sgAccount: '',
        type: null,
        name: '',
        status: null,
        term: null,
        taxCode: null,
        chequeName: '',
        creditLimit: '',
        CreditDays: '',
        VatRegNo: '',
        TradeLicenceNo: '',
        Discount: '',
        PhonrNo: '',
        faxNo: '',
        mobileNo: '',
        email: '',
        web: '',
        address: '',
        line1: '',
        line2: '',
        country: null,
        city: null,

    });

    useEffect(() => {
        getItems();
    }, []);
    const getItems = async () => {
        try {
            const financialRes = await apiService.get('GET_FINANCIAL_YEAR');
            const selectedFinancialYear = financialRes?.data?.data?.find(po => po?.isActive === true);
            setFiinancialYear(selectedFinancialYear)
            const params = new URLSearchParams();
            params.append('financialYear', selectedFinancialYear?.id);
            const response = await apiService.getApiParamater('GET_DROP_DOWN', `?${params.toString()}`)
            let data = response?.data?.data
            setSubGroupList(data?.subGroups)
            setCountryList(data?.countries)
            setTaxList(data?.taxes)
            setTermList(data?.paymentTerms)
            setStatusList(data?.statuses)
            setTypeList(data?.supplierTypes)
            setAccountList(data?.accounts)
            setBankList(data?.accounts)
            setBankCategoryList(data?.accounts)
            const res = await apiService.getApiParamater('GET_SUPPLIER_DATA', `${supplierData?.id}`)
            let supData = res?.data?.data
            let sup = supData?.supplier
            let param = `/${sup?.country}`
            const cityResponse = await apiService.getApiParamater('GET_CITIES', param)
            setCityList(cityResponse?.data?.data)
            const selectedTax = data?.taxes?.find(dep => dep.id === sup?.taxCode.toString())
            setSupplierData({
                ...supplierdata,
                subgroup: { label: sup?.value || "", value: sup?.text || "" },
                accountcode: sup?.accountCode || "",
                accountname: sup?.accountName || "",
                creditfacility: sup?.hasCreditFacility || false,
                vatRegistered: false,
                createLedger: false,
                SapAccountCode: sup?.sapAccountCode || false,
                sgAccount: sup?.sGCode || '',
                type: { label: sup?.supplierType || "", value: sup?.supplierType || "" },
                name: sup?.supplierName || '',
                status: { label: sup?.status || "", value: sup?.status || "" },
                term: { label: sup?.paymentTerm || "", value: sup?.paymentTerm || "" },
                taxCode: { label: selectedTax?.name || "", value: selectedTax || "" },
                chequeName: sup?.chequePrintName || '',
                creditLimit: sup?.creditLimit || '',
                CreditDays: sup?.creditDays || '',
                VatRegNo: sup?.vATRegNo || '',
                TradeLicenceNo: sup?.tradeLicenceNo || '',
                Discount: sup?.discount || '',
                PhonrNo: sup?.phoneNo1 || '',
                faxNo: sup?.faxNo1 || '',
                mobileNo: sup?.mobileNo1 || '',
                email: sup?.email1 || '',
                web: sup?.web || '',
                address: sup?.address1 || '',
                line1: sup?.address2 || '',
                line2: sup?.address3 || '',
                country: { label: sup?.country || "", value: sup?.country || "" },
                city: { label: sup?.city || "", value: sup?.city || "" },
            });
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    }
    const handleInputChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;
        setSupplierData((prev) => ({
            ...prev,
            [name]: value
        }));
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "country") {
            let param = `/${value?.label}`
            const cityResponse = await apiService.getApiParamater('GET_CITIES', param)
            setCityList(cityResponse?.data?.data)
        }
        setSupplierData(prev => ({ ...prev, [name]: value }));
    };
    const handleBackClick = () => {
        window.history.back();
    }
    const handleSave = async () => {
        try {
            setLoader(true);
            if (!supplierdata?.type?.label) {
                toast.warning("Select Supplier type");
                setLoader(false);
                return;
            } else if (!supplierdata?.name) {
                toast.warning("Enter Supplier Name");
                setLoader(false);
                return;
                // } else if (!supplierdata?.PhonrNo) {
                //     toast.warning("Enter Phone No");
                //     setLoader(false);
                //     return;
            } else if (!supplierdata?.country?.label) {
                toast.warning("Enter Country");
                setLoader(false);
                return;
            } else if (!supplierdata?.city?.label) {
                toast.warning("Enter city");
                setLoader(false);
                return;
            }
            const userData = {
                supplierType: supplierdata?.type?.label || "0",
                supplierName: supplierdata?.name || "0",
                accountCode: supplierdata?.accountcode || "0",
                accountName: "0",
                address1: supplierdata?.address || "0",
                address2: supplierdata?.line1 || "0",
                address3: supplierdata?.line2 || "0",
                city: supplierdata?.city?.label || "0",
                country: supplierdata?.country?.label || "0",
                phoneNo1: supplierdata?.PhonrNo || "0",
                phoneNo2: "0",
                phoneNo3: "0",
                faxNo1: supplierdata?.faxNo || "0",
                faxNo2: "0",
                mobileNo1: supplierdata?.mobileNo || "0",
                mobileNo2: "0",
                email1: supplierdata?.email || "0",
                email2: "0",
                web: supplierdata?.web || "0",
                contactPerson1: "0",
                cP1ContactNo1: "0",
                cP1ContactNo2: "0",
                cP1Email: "0",
                contactPerson2: "0",
                cP2ContactNo1: "0",
                cP2ContactNo2: "0",
                cP2Email: "0",
                chequePrintName: supplierdata?.chequeName || "0",
                paymentTerm: supplierdata?.term?.label || "0",
                hasCreditFacility: supplierdata?.creditfacility || false,
                creditLimit: parseFloat(supplierdata?.creditLimit || 0),
                creditDays: parseFloat(supplierdata?.CreditDays || 0),
                discount: supplierdata?.Discount || "0",
                createLedger: supplierdata?.createLedger || false,
                sgCode: supplierdata?.sgAccount?.label || "0",
                createAdvanceLedger: false,
                advanceAcCode: "0",
                advanceAcName: "0",
                advanceSGCode: "0",
                createRetentionLedger: false,
                retentionAcCode: "0",
                retentionAcName: "0",
                retentionSGCode: "0",
                vatRegNo: supplierdata?.VatRegNo || "0",
                taxCode: supplierdata?.taxCode?.value?.id || 0,
                status: supplierdata?.status?.label || "0",
                sapAccountCode: supplierdata?.SapAccountCode || "0",
                tradeLicenceNo: supplierdata?.TradeLicenceNo || "0",
                createdBy: fulname || "",
                supplierBanks: [
                    {
                        recordId: 0,
                        bankName: "0",
                        accountCode: "0",
                        iban: "0",
                        swift: "0",
                        branch: "0",
                        city: "0",
                        country: "0",
                        contactPerson: "0",
                        contactNo: "0",
                        corBankId: 0,
                        category: "0"
                    }
                ],
                attachments: [
                    {
                        recordId: 0,
                        fileName: "",
                        description: ""
                    }
                ]
            }
            debugger
            const response = await apiService.putApiParamater(
                "UPDATE_SUPPLIER",
                supplierData?.id,
                {
                    ...userData,
                    id: supplierData?.id,
                    supplierId: supplierData?.supplierId || "",
                    deletedBankIds: [],
                    deletedAttachments: []
                }
            );
            debugger
            if (response?.status === 200 || response?.status === 201) {
                toast.success(`Supplier Created successfully`);
                setLoader(false);
                navigate("/Inventory/Master/Supplier/Listing")
            } else if (response?.data?.statusCode === 208) {
                setLoader(false)
            }
        } catch (error) {
            setLoader(false);
            console.error('Error Creating User:', error);
        }
    }
    return (
        <div className="p-4">
            <div className='border-box2 p-2 d-flex justify-content-between' style={{ borderRadius: "8px" }}>
                <div className='center'><h4 className='mainInvHead'>Create Supplier</h4></div>
                <div className='gap-3 d-flex'>
                    {loading === true ?
                        <div className='mainbtn flex-end gap-2'>
                            <ClipLoader color="#ffffff" className='mt-1' size={25} />
                        </div>
                        :
                        <div className='mainbtn flex-end gap-2' onClick={handleSave}>
                            <FaSave color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Save</div>
                        </div>
                    }
                    <div className='mainbtnSecondary flex-end gap-2' onClick={handleBackClick}>
                        <FaChevronLeft color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Back</div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section mt-2">
                <div className={`border-box2 p-3`}>
                    <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))', gap: '20px' }}>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Supplier Type *</label>
                            <Select
                                className="p-0 w-100"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                        color: state.isFocused ? "#000 " : "#000",
                                        ":hover": {
                                            backgroundColor: "#F5F5F5",
                                            color: "#000 ",
                                        },
                                    }),
                                }}
                                value={supplierdata.type}
                                options={typeList?.map((sup) => ({ value: sup, label: sup?.name }))}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'type', value: selectedOption })}
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Supplier Name *</label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.name} onChange={handleInputChange} name="name" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom18" className="form-label">Status *</label>
                            <Select
                                className="p-0 w-75"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                        color: state.isFocused ? "#000 " : "#000",
                                        ":hover": {
                                            backgroundColor: "#F5F5F5",
                                            color: "#000 ",
                                        },
                                    }),
                                }}
                                value={supplierdata.status}
                                options={statusList?.map((sup) => ({ value: sup, label: sup?.name }))}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'status', value: selectedOption })}
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Payment Term</label>
                            <Select
                                className="p-0 w-100"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                        color: state.isFocused ? "#000 " : "#000",
                                        ":hover": {
                                            backgroundColor: "#F5F5F5",
                                            color: "#000 ",
                                        },
                                    }),
                                }}
                                value={supplierdata.term}
                                options={termList?.map((sup) => ({ value: sup, label: sup?.name }))}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'term', value: selectedOption })}
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom19" className="form-label">Tax Code</label>
                            <Select className="p-0 w-100"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                        color: state.isFocused ? "#000 " : "#000",
                                        ":hover": {
                                            backgroundColor: "#F5F5F5",
                                            color: "#000 ",
                                        },
                                    }),
                                }}
                                value={supplierdata.taxCode}
                                options={taxList?.map((sup) => ({ value: sup, label: sup?.name }))}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'taxCode', value: selectedOption })}
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Cheque Name</label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.chequeName} onChange={handleInputChange} name="chequeName" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Credit Limit</label>
                            <input type="number" className="p-2 form-Input w-75" value={supplierdata?.creditLimit} onChange={handleInputChange} name="creditLimit" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Credit Days</label>
                            <input type="number" className="p-2 form-Input w-75" value={supplierdata?.CreditDays} onChange={handleInputChange} name="CreditDays" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Credit Facility</label>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="active"
                                style={{ width: '20px', height: '20px' }}
                                checked={supplierdata.creditfacility}
                                onChange={(e) => setSupplierData(prev => ({ ...prev, creditfacility: e.target.checked }))}
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">VAT Reg No</label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.VatRegNo} onChange={handleInputChange} name="VatRegNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Vat Registered</label>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="active"
                                style={{ width: '20px', height: '20px' }}
                                checked={supplierdata.vatRegistered}
                                onChange={(e) => setSupplierData(prev => ({ ...prev, vatRegistered: e.target.checked }))}
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Trade Licence No</label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.TradeLicenceNo} onChange={handleInputChange} name="TradeLicenceNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Discount</label>
                            <input type="number" className="p-2 form-Input w-75" value={supplierdata?.Discount} onChange={handleInputChange} name="Discount" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Phone No </label>
                            <input type="number" className="p-2 form-Input w-75" value={supplierdata?.PhonrNo} onChange={handleInputChange} name="PhonrNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Fax No</label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.faxNo} onChange={handleInputChange} name="faxNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Mobile No</label>
                            <input type="number" className="p-2 form-Input w-75" value={supplierdata?.mobileNo} onChange={handleInputChange} name="mobileNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                            <input type="email" className="p-2 form-Input w-75" value={supplierdata?.email} onChange={handleInputChange} name="email" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Web</label>
                            <input type="url" className="p-2 form-Input w-75" value={supplierdata?.web} onChange={handleInputChange} name="web" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Address</label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.address} onChange={handleInputChange} name="address" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">line 2 </label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.line1} onChange={handleInputChange} name="line1" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Line 3</label>
                            <input type="text" className="p-2 form-Input w-75" value={supplierdata?.line2} onChange={handleInputChange} name="line2" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Country</label>
                            <Select
                                className="p-0 w-100"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                        color: state.isFocused ? "#000 " : "#000",
                                        ":hover": {
                                            backgroundColor: "#F5F5F5",
                                            color: "#000 ",
                                        },
                                    }),
                                }}
                                value={supplierdata.country}
                                options={countryList?.map((sup) => ({ value: sup, label: sup?.name }))}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'country', value: selectedOption })}
                            />
                        </div>

                        <div className="d-flex">
                            <label htmlFor="validationCustom19" className="form-label">City</label>
                            <Select className="p-0 w-100"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                        color: state.isFocused ? "#000 " : "#000",
                                        ":hover": {
                                            backgroundColor: "#F5F5F5",
                                            color: "#000 ",
                                        },
                                    }),
                                }}
                                value={supplierdata.city}
                                options={cityList?.map((sup) => ({ value: sup, label: sup?.name }))}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'city', value: selectedOption })}
                            />
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
};
export default UpdateSupplier